import { render, staticRenderFns } from "./EventDetails.vue?vue&type=template&id=a2c81a28&scoped=true&"
import script from "./EventDetails.vue?vue&type=script&lang=ts&"
export * from "./EventDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetails.vue?vue&type=style&index=0&id=a2c81a28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c81a28",
  null
  
)

export default component.exports